var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Dialog,{attrs:{"dialog":_setup.dlg}},[_c(_setup.FileDrop,{attrs:{"isLoading":_setup.dlg.isUploading},on:{"filesSelected":(a,b,c,d) => _setup.dlg.onFilesSelected(a,b,c,d)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }